import React, { memo, useEffect, useState } from 'react';
import { ImagePlaceholder } from '../ImagePlaceholder';
import './JCard.scss';
import { Props } from './JCard.types';
import {useJCommonContext} from "../JCommonProvider";

const noop = () => {};

const _JCard: React.FC<Props> = ({
  type,
  proportions = '1:2',
  headerTitle,
  coverImageUrl,
  headerContent,
  contentComponent,
  reversed = false,
  onClick = noop
}) => {
  const {getImageURL} = useJCommonContext();
  const [imgExists, setImgExists] = useState<boolean>();

  useEffect(() => {
    if (coverImageUrl) {
      fetch(coverImageUrl, { method: 'HEAD' })
        .then(res => setImgExists(!!res.ok))
        .catch(() => setImgExists(false));
    }
  }, []);

  let displayDirection = reversed ? 'column-reverse' : 'column';
  if (type === 'horizontal') {
    displayDirection = reversed ? 'row-reverse' : 'row';
  }

  const proportionSlice = proportions.split(':');

  if (proportionSlice.length !== 2) {
    throw new Error('Please provide a proportion in the following format: 1:2');
  }

  const [contentFlex, headerFlex] = proportionSlice;

  const CSSVars = {
    '--content-flex': contentFlex,
    '--header-flex': headerFlex,
    '--display-direction': displayDirection,
    cursor: onClick === noop ? 'initial' : 'pointer',
  } as React.CSSProperties;

  return (
    <div className={`jcard-container`} style={CSSVars} onClick={onClick}>
      <div className="jcard-header">
        {!!headerTitle && (
          <div className="jcard-header-title">{headerTitle}</div>
        )}
        {coverImageUrl && imgExists !== undefined && (
          imgExists ?
            <img
              src={getImageURL(coverImageUrl)}
              className="jcard-cover-image"
              loading="lazy"
              aria-hidden={true}
            /> :
            <ImagePlaceholder
              className="jcard-cover-image"
            />
          )
        }
        {!!headerContent && (
          <div className="jcard-header-content">{headerContent}</div>
        )}
      </div>
      <div className="jcard-content">{contentComponent}</div>
    </div>
  );
};

export const JCard = memo(_JCard);
